import { z } from "zod";
import { ReturnProductSchema } from "../draft-return/draft-return-items";
import { Provider } from "../order";
import { ShopifyGraphQLProductSchema as ProductDataSchema } from "../product";

export const ExchangeRecommendationsSchema = z.array(ProductDataSchema);

export const GenerateExchangeRecommendationsInputSchema = z.object({
  provider: z.nativeEnum(Provider),
  returnedProduct: ReturnProductSchema,
  reasons: z.array(z.object({ prompt: z.string(), answer: z.string() })),
});

export type GenerateExchangeRecommendationsInput = z.infer<
  typeof GenerateExchangeRecommendationsInputSchema
>;

export type ExchangeRecommendations = z.infer<
  typeof ExchangeRecommendationsSchema
>;
